import type { AvatarSource as RpcAvatarSource } from '../../__generated__/chirp/com/hubspot/avatars/rpc/AvatarsRpc';
import { AVATAR_SOURCES, AvatarSource } from '../lib/AvatarSources';
import type { Type } from '../types/SharedPropTypes';

const CONTACT_TYPES = new Set<Type>([
  'contact',
  'vid',
  'email',
  'emails',
  'enrichmentEmail',
]);

const COMPANY_TYPES = new Set<Type>([
  'company',
  'companyId',
  'domain',
  'enrichmentDomain',
]);

const PRODUCT_TYPES = new Set<Type>(['productId']);

type SourceCategory = 'contact' | 'company' | 'product' | 'unknown';

function getSourceCategory(lookupType: Type): SourceCategory {
  if (CONTACT_TYPES.has(lookupType)) return 'contact';
  if (COMPANY_TYPES.has(lookupType)) return 'company';
  if (PRODUCT_TYPES.has(lookupType)) return 'product';
  return 'unknown';
}

const SOURCE_MAP: Partial<
  Record<RpcAvatarSource, Record<SourceCategory, AvatarSource>>
> = {
  DEFAULT: {
    contact: AVATAR_SOURCES.CONTACT_DEFAULT,
    company: AVATAR_SOURCES.COMPANY_DEFAULT,
    product: AVATAR_SOURCES.PRODUCT_DEFAULT,
    unknown: AVATAR_SOURCES.UNKNOWN,
  },
  OVERRIDE: {
    contact: AVATAR_SOURCES.CONTACT_OVERRIDE,
    company: AVATAR_SOURCES.COMPANY_OVERRIDE,
    product: AVATAR_SOURCES.PRODUCT_OVERRIDE,
    unknown: AVATAR_SOURCES.UNKNOWN,
  },
  ENRICHMENT: {
    contact: AVATAR_SOURCES.CONTACT_ENRICHMENT,
    company: AVATAR_SOURCES.COMPANY_ENRICHMENT,
    product: AVATAR_SOURCES.UNKNOWN,
    unknown: AVATAR_SOURCES.UNKNOWN,
  },
  INHERITED_OVERRIDE: {
    contact: AVATAR_SOURCES.CONTACT_OVERRIDE,
    company: AVATAR_SOURCES.UNKNOWN,
    product: AVATAR_SOURCES.UNKNOWN,
    unknown: AVATAR_SOURCES.UNKNOWN,
  },
  INHERITED_ENRICHMENT: {
    contact: AVATAR_SOURCES.CONTACT_ENRICHMENT,
    company: AVATAR_SOURCES.UNKNOWN,
    product: AVATAR_SOURCES.UNKNOWN,
    unknown: AVATAR_SOURCES.UNKNOWN,
  },
};

export function mapRpcAvatarSource(
  rpcSource: RpcAvatarSource,
  lookupType: Type | undefined
): AvatarSource {
  if (!lookupType) return AVATAR_SOURCES.UNKNOWN;
  const category = getSourceCategory(lookupType);
  return SOURCE_MAP[rpcSource]?.[category] ?? AVATAR_SOURCES.UNKNOWN;
}
